import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for D504 (託工入庫單核准)
// ============================================================

export interface PendingItem {
  fd140_01: string;        // 入庫單號
  fd140_10: string;        // 加工廠代號
  fd140_11: string;        // 託工單號
  fd140_12: string | null; // 入庫日期 (ISO string)
  fd140_13: string;        // 庫位代號
  fd140_16: number;        // 工繳總金額
  fd140_21: number;        // 總入庫量
  fd140_91: string;        // 建單人員
  factory_name: string;    // 加工廠名稱 (FD132M lookup)
  can_approve: boolean;    // 此用戶是否可核准
}

export interface QueryResponse {
  items: PendingItem[];
  total: number;
}

export interface ApproveResultItem {
  receipt_no: string;
  success: boolean;
  message: string;
}

export interface ExecuteResponse {
  results: ApproveResultItem[];
  success: number;
  failed: number;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export function createD504Api(basePath = '/api/d504') {
  return {
  /** Query pending subcontract receipt orders within a range */
  async query(startNo: string, endNo: string): Promise<QueryResponse> {
    const res = await apiClient.post<QueryResponse>(`${basePath}/query`, {
      start_no: startNo,
      end_no: endNo,
    });
    return res.data;
  },

  /** Execute batch approval for selected subcontract receipt orders */
  async execute(receiptNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post<ExecuteResponse>(`${basePath}/execute`, {
      receipt_nos: receiptNos,
      confirmed: true,
    });
    return res.data;
  },
  };
}

export const d504Api = createD504Api();
export const d514Api = createD504Api('/api/d514');
